<template>
    <div v-if="booking.services.length">
        <hr>
        <div class="ibox p-bottom-0 m-bottom-0">
            <p class="p-0-18 mobile-p-0-6" style="margin-top: 15px">
                <span class="cost-title">Cost</span>
            </p>
            <div class="ibox-content ibox-content-mobile border-none p-bottom-0 m-bottom-0">
                <div class="form-group price-form-group p-bottom-0 m-bottom-0">
                    <fieldset class="m-bottom-0-important">

                        <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                            <booking-voucher-field :subtotal="subtotal" :services="booking.services"
                                                   :total="totalWithoutVoucher"
                                                   v-model="voucher"></booking-voucher-field>
                        </div>

                        <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                            <booking-discount-included-field :discount="discount"
                                                             :currency="currency"></booking-discount-included-field>
                            <booking-minimum-charge v-model="minimumChargeEnabled"
                                                    :minimum-charge="minimumCharge"
                                                    :currency="currency"></booking-minimum-charge>
                        </div>
                        <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                            <booking-product-quote :product-quote="productQuote"
                                                   :currency="currency"></booking-product-quote>

                            <booking-service-quote :service-quote="serviceQuote"
                                                   :currency="currency"></booking-service-quote>

                        </div>
                        <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                            <booking-cancellation-fee v-if="status===7" :confirmed-from-popup="confirmedFromPopup"
                                                      :cancellation-fee="cancellationFee" :currency="currency"
                                                      v-model="cancellationFee" @reset-cancelation-fee="handleCancelFeeReset"></booking-cancellation-fee>
                            <booking-call-out-fee v-if="status===5" :confirmed-from-popup="confirmedFromPopup"
                                                  :call-out-fee="callOutFee" :currency="currency"
                                                  v-model="callOutFee" @reset-fee="handleFeeReset"></booking-call-out-fee>
                        </div>
                        <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                            <booking-subtotal-field :subtotal="subtotal"
                                                    :currency="currency"></booking-subtotal-field>
                            <booking-tax-fields v-if="taxes && booking.services[0].showTaxRate" :taxes="taxes"
                                                v-model="totalTax"
                                                :minimum-charge-enabled="minimumChargeEnabled"
                                                :cancellation-fee="cancellationFee"
                                                :call-out-fee="callOutFee"
                                                :tax-included="company.include_tax"
                                                :currency="currency"></booking-tax-fields>
                        </div>
                        <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                            <booking-total-field :total="total"
                                                 :currency="currency"></booking-total-field>
                            <booking-deposit-field :key="depositKey"
                                v-if="(booking.company.deposit && !itemId) || (itemId && status!==7 && status !==5) && !booking.duplicate"
                                v-model="deposit"
                                :paid-amount="paidAmount"
                                :merged-invoice="bookingSummary.merged_invoice"

                                :currency="currency"></booking-deposit-field>
                        </div>
                        <div v-if="!booking.duplicate" v-show="itemId && !bookingSummary.merged_invoice" class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                            <booking-paid-amount :paid-amount="paidAmount" :currency="currency"></booking-paid-amount>
                            <booking-balance-due :balance-due="balanceDue" :currency="currency"></booking-balance-due>
                        </div>
                        <div  v-if="!booking.duplicate" v-show="itemId && !bookingSummary.merged_invoice">
                            <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                                <booking-referal-code-discount v-if="bookingSummary.referral_code_discount"
                                                               :referal-code="bookingSummary.referral_code_discount"
                                                               :currency="currency"></booking-referal-code-discount>
                                <booking-surcharge v-if="bookingSummary.surcharge.surcharge_value"
                                                   :surcharge="bookingSummary.surcharge"
                                                   :currency="currency"></booking-surcharge>
                            </div>


                            <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom"
                                 v-if="bookingSummary.tip.tip_amount">
                                <booking-tip-amount :tip="bookingSummary.tip" :currency="currency"></booking-tip-amount>
                                <booking-tip-tax :tip="bookingSummary.tip" :currency="currency"></booking-tip-tax>
                            </div>


                            <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                                <booking-first-time-offer v-if="bookingSummary.first_time_offer"
                                                          :first-time-offer="bookingSummary.first_time_offer"
                                                          :currency="currency"></booking-first-time-offer>
                                <booking-refund v-if="bookingSummary.refund" :refund="bookingSummary.refund"
                                                :currency="currency"></booking-refund>
                            </div>


                            <div class="row m-right-0 m-bottom-12 mobile-no-margin-bottom">
                                <booking-authourized v-if="bookingSummary.pre_auth_amount"
                                                     :authourized="bookingSummary.pre_auth_amount"
                                                     :currency="currency"></booking-authourized>
                                <booking-pending-approval v-if="bookingSummary.unapproved_paid_amount"
                                                          :pending-approval="bookingSummary.unapproved_paid_amount"
                                                          :currency="currency"></booking-pending-approval>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {getCompanyInformation} from "@/modules/Services/api/billing"

export default {
    name: "BookingPricing",
    props: {
        booking: [],
        currency: {
            required: true,
        },
        viewPage:false,
        considerBookingMinPrice: false,
        itemId: 0,
        bookingSummary: {},
        voucherValue: {},
        bookingCustomers:{},
        allowMultiCustomers:0
    },
    data() {
        return {
            company: {},
            pricing: [],
            cancellationFee: (this.booking || {}).bookingStatusId===7 ?(this.booking || {}).cancellationFee:0,
            callOutFee:  (this.booking || {}).bookingStatusId===5 ? (this.booking || {}).callOutFee:0,
            voucher: this.voucherValue ?? null,
            totalTax: 0,
            status: (this.booking || {}).bookingStatusId??4,
            deposit: this.bookingSummary.booking_deposit ?? 0,
            confirmedFromPopup: this.viewPage,
            minimumChargeEnabled: false,
            paidAmount: this.bookingSummary.paid_amount,
            fullyLoaded: false,
            depositKey: 0
        }
    },
    computed: {
        discount() {
            let discount = 0;

            for (let price of this.pricing)
                discount += parseFloat(price.discount)

            return discount
        },
        minimumCharge() {
            let charge = 0;

            if (this.minimumChargeEnabled) {
                for (let price of this.pricing)
                    charge += price.minimumCharge
                return charge
            }

            for (let price of this.pricing) {
                if (price.minimumChargeEnabled)
                    charge += price.minimumCharge
            }

            return charge
        },
        subtotal() {
            let total = 0;
            if (this.cancellationFee && this.booking.bookingStatusId===7) {
                return +this.cancellationFee
            }
            if (this.callOutFee && this.booking.bookingStatusId===5) {
                return +this.callOutFee
            }
            for (let price of this.pricing)
                total += +price.subtotal


            total = Math.max(total, this.minimumCharge)

            return parseFloat(total)
        },

        productQuote() {
            let total = 0;
            for (let price of this.pricing)
                total += +price.productAmount
            // total = Math.max(total, this.minimumCharge)
            return parseFloat(total)
        },
        serviceQuote() {
            let total = 0;
            for (let price of this.pricing)
                total += +price.serviceAmount
            // total = Math.max(total, this.minimumCharge)
            return parseFloat(total)
        },
        balanceDue() {
            let total = this.total - this.paidAmount;
            if (this.bookingSummary.surcharge.surcharge_value){
              total = total - this.bookingSummary.surcharge.surcharge_value
            }
            if(this.bookingSummary.tip.tip_amount ){
              total = total- this.bookingSummary.tip.tip_amount
            }

            return parseFloat(total).toFixed(2)
        },
        totalTaxForDepositData() {
            let sum = 0;
            for (let tax of this.taxes) {
                if (this.cancellationFee && this.booking.bookingStatusId ===7)
                    sum += 0
                else if (this.minimumChargeEnabled)
                    sum += tax.valueWithMinimumCharge
                else
                    sum += tax.value
            }
            return sum
        },
        taxes() {
            let priceTaxes = [];
            for (let price of this.pricing) {
                if (Array.isArray(price.taxRate)) {
                    for (let priceTax of price.taxRate) {
                        priceTaxes.push(priceTax)
                    }
                } else if (price.taxRate) {
                    priceTaxes.push(price.taxRate)
                }

            }
            return priceTaxes
        },
        totalWithoutVoucher() {
            if (this.booking.company.include_tax)
                return +this.subtotal

            return +this.subtotal + +this.totalTax
        },
        total() {
            let total = 0;
            if (this.cancellationFee && this.booking.bookingStatusId ===7 && !this.booking.duplicate) {
                return +this.cancellationFee
            }
            if (this.callOutFee && this.booking.bookingStatusId ===5  && !this.booking.duplicate) {
                return +this.callOutFee
            }
            // console.log(this.voucher);
            if ((this.booking.company || {}).include_tax || !this.totalTax  && !this.booking.duplicate) {
                total = +this.subtotal
            } else {
                total = +this.subtotal + +this.totalTax
            }
            if (this.bookingSummary && this.bookingSummary.surcharge.surcharge_value  && !this.booking.duplicate) {
                total += +this.bookingSummary.surcharge.surcharge_value
            }
            if (this.bookingSummary && this.bookingSummary.tip.tip_amount  && !this.booking.duplicate) {
                //  window.alert(this.bookingSummary.tip.tip_tax.tax_value);
                total += +this.bookingSummary.tip.tip_amount + +this.bookingSummary.tip.tip_tax.tax_value
            }
            if (this.voucher) {
                if (this.voucher.type == 'PERCENT') {
                    return total - (total * (this.voucher.value / 100));
                    // return total - parseFloat(this.voucher.value_percent);
                } else {
                    return total - this.voucher.value
                }
            }

          if(this.allowMultiCustomers){
            if(!this.booking.services[0].split_price){
              total = total * this.booking.customers.length
            }
          }

            return total;
        }
    },
    methods: {
        setCompanyInformation() {
            getCompanyInformation()
                .then((response) => this.booking.company = response.data)
        },
        addEventListeners() {
            EventBus.$on('onPricesUpdated', pricing => {
              if (JSON.stringify(this.pricing) != JSON.stringify(pricing)){
                EventBus.$emit('serviceChanged',pricing);
                  this.pricing = pricing
              }
            })
            EventBus.$on('onBookingStatusChange', (statues) => {
                this.status = statues.booking_status_id;
            })
            EventBus.$on('feePopupChanged', (confirmed, feeValue, type) => {
                if (type === 'cancel') {
                    this.cancellationFee = feeValue;
                } else if (type === 'callOut') {
                    this.callOutFee = feeValue;
                }
                this.confirmedFromPopup = confirmed;
            })
          EventBus.$on('onVoucherAdded', () => {
            if(this.booking.company.deposit.amount_type=="percent"){
              this.deposit = (this.booking.company.deposit.amount * this.total/100).toFixed(2)
              this.depositKey++//rerender child component
            }
          })
        },
        activateMinimumChargeFieldInCaseOfEdit() {
            if (this.considerBookingMinPrice) {
                this.minimumChargeEnabled = true;
            }
        },
        handleFeeReset() {
            this.callOutFee = 0; // Or whatever your reset value should be
        },
        handleCancelFeeReset(){
            this.cancellationFee = 0
        }
    },
    mounted() {
      this.cancellationFee = this.booking && this.booking.bookingStatusId ===7?(this.booking.cancellationFee??this.booking.company?.cancellation_fee):0
      this.callOutFee = this.booking && this.booking.bookingStatusId ===5?(this.booking.callOutFee??this.booking.company?.call_out_fee):0

        EventBus.$on('onValidateBookingForm', function (data, handler) {
            handler();
        })


        this.activateMinimumChargeFieldInCaseOfEdit()

        setTimeout(() => {
            this.fullyLoaded = true;
        }, 3500)

    },
    created() {
        // this.setCompanyInformation()
        this.addEventListeners()
    },
    watch: {
        subtotal(subtotal) {
            if (!this.fullyLoaded && this.bookingSummary.booking_deposit != 0) {
                /** calculate deposit when booking deposit equal zero  **/
                return
            }
            if (!this.booking.company.deposit || !this.total) {
                return 0
            }
            if (this.booking.company.deposit.amount_type === "percent") {
                this.deposit = +(subtotal + parseFloat(this.totalTaxForDepositData)) * (+this.booking.company.deposit.amount / 100)
            } else if (this.booking.company.deposit.payment_collection_name === "full_payment") {
                this.deposit = +subtotal + parseFloat(this.totalTaxForDepositData)
            } else {
                this.deposit = +(this.booking?.company?.deposit?.amount?.toFixed(2) ?? "0");
            }
        },
      deposit: {
        handler: function (value,oldValue) {
          if (JSON.stringify(oldValue) != JSON.stringify(value)){
              EventBus.$emit('serviceChanged', value)
          }
        },
        deep: true
      },
    }
}
</script>

<style scoped>
.m-bottom-0-important {
    margin-bottom: 0px !important;
}
@media (max-width: 991px) {
    .ibox-content {
        padding-right: 20px !important;
        padding-left: 20px !important;
    }
}
</style>